/**
 * Calculates freelance hourly rate based on desired income, expenses, and realistic billable hours.
 */
export function calculateFreelanceRate(input) {
    const { desiredIncome, businessExpenses, taxRate, billableHoursPerWeek, weeksPerYear } = input;

    if (!desiredIncome || desiredIncome <= 0 || !billableHoursPerWeek || billableHoursPerWeek <= 0) {
        return null;
    }

    // 1. Calculate gross income needed to cover taxes
    const grossIncome = (desiredIncome + businessExpenses) / (1 - (taxRate / 100));
    const taxesPaid = grossIncome - (desiredIncome + businessExpenses);

    // 2. Calculate total annual billable hours
    const totalBillableHours = billableHoursPerWeek * weeksPerYear;

    // 3. Calculate hourly rate
    const hourlyRate = grossIncome / totalBillableHours;

    return {
        grossIncome: Math.round(grossIncome),
        taxesPaid: Math.round(taxesPaid),
        totalBillableHours: Math.round(totalBillableHours),
        hourlyRate: hourlyRate.toFixed(2)
    };
}
